var map = {
	"./av_baboon.png": 68391,
	"./av_badger.png": 15421,
	"./av_bear.png": 40041,
	"./av_bee.png": 98350,
	"./av_beta.png": 81545,
	"./av_bunny.png": 12059,
	"./av_butterfly.png": 622,
	"./av_cardinal.png": 86145,
	"./av_cat.png": 28021,
	"./av_cockatoo.png": 19002,
	"./av_crab.png": 98553,
	"./av_crane.png": 15016,
	"./av_dragonfly.png": 27711,
	"./av_eagle.png": 89737,
	"./av_egret.png": 13346,
	"./av_elephant.png": 22680,
	"./av_flamingo.png": 34005,
	"./av_fox.png": 4552,
	"./av_gazelle.png": 46552,
	"./av_giraffe.png": 3684,
	"./av_gorilla.png": 96731,
	"./av_hedgehog.png": 47268,
	"./av_hippo.png": 19669,
	"./av_horse.png": 53994,
	"./av_hummingbird.png": 7020,
	"./av_iguna.png": 90783,
	"./av_jellyfish.png": 52268,
	"./av_leopard.png": 15032,
	"./av_lion.png": 5316,
	"./av_lionfish.png": 44734,
	"./av_lizard.png": 55887,
	"./av_macaw.png": 24947,
	"./av_mantis.png": 28067,
	"./av_octopus.png": 5830,
	"./av_orangutan.png": 85186,
	"./av_osprey.png": 67685,
	"./av_otter.png": 48605,
	"./av_owl.png": 42437,
	"./av_panda.png": 82290,
	"./av_pangolin.png": 93878,
	"./av_panther.png": 4904,
	"./av_peacock.png": 48672,
	"./av_penguin.png": 21595,
	"./av_polar bear.png": 12729,
	"./av_puffin.png": 23254,
	"./av_puppy.png": 71903,
	"./av_rhino.png": 76222,
	"./av_rooster.png": 37283,
	"./av_shark.png": 221,
	"./av_sloth.png": 49879,
	"./av_snake.png": 62854,
	"./av_squirrel.png": 57961,
	"./av_starfish.png": 60532,
	"./av_stingray.png": 25710,
	"./av_tiger.png": 41895,
	"./av_tucan.png": 10490,
	"./av_turtle.png": 5568,
	"./av_walrus.png": 68531,
	"./av_whaleshark.png": 63598,
	"./av_yak.png": 23120,
	"./av_zebra.png": 6559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88261;